import { Component, OnInit } from '@angular/core';
import {
  ADD_NUMBERS_TO_BLACKLIST_SUCCESS,
  AddNumbersToBlacklistAction,
  REMOVE_NUMBERS_TO_BLACKLIST_SUCCESS,
  RemoveNumbersToBlacklistAction
} from '../blacklist/blacklist.actions';
import { IState } from '../../shared/models/state';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { ActivatedRoute, Router } from '@angular/router';
import { ImportAction } from '../blacklist/blacklist';

const nextLineSymbol = '\n';

@Component({
  selector: 'cc-manual-import-contact',
  templateUrl: './manual-import-contacts.component.html',
  styleUrls: ['./manual-import-contacts.component.scss']
})
export class ManualImportContactsComponent implements OnInit {
  public textareaRows = 15;
  private placeholder = 'Phone number...';
  public textareaPlaceholder = '';
  public action: ImportAction;

  constructor(
    private store: Store<IState>,
    private route: ActivatedRoute,
    private router: Router,
    private action$: Actions
  ) {}

  ngOnInit() {
    this.action = this.route.snapshot.data['action'];
    this.generatePlaceholder();
  }

  generatePlaceholder() {
    let i;
    for (i = 0; i < this.textareaRows; i++) {
      this.textareaPlaceholder += `${this.placeholder}${nextLineSymbol}`;
    }
  }

  actionNumbersToBlackList(textareaValues) {
    if (this.action === ImportAction.ADD) {
      this.store.dispatch(new AddNumbersToBlacklistAction(textareaValues.split(nextLineSymbol)));
    }
    if (this.action === ImportAction.REMOVE) {
      this.store.dispatch(new RemoveNumbersToBlacklistAction(textareaValues.split(nextLineSymbol)));
    }

    this.action$
      .ofType(ADD_NUMBERS_TO_BLACKLIST_SUCCESS, REMOVE_NUMBERS_TO_BLACKLIST_SUCCESS)
      .take(1)
      .subscribe(() => {
        this.router.navigate(['/', 'blacklist']);
      });
  }
}
